import React from 'react';
import { DropdownSearchField } from './dropdown_search';

export const DropdownSearchMultipleField = (props) => {
  return (
    <DropdownSearchField
      {...props}
      multiple={true}
    />
  );
}
